import { useEffect, useState } from 'react';
import axios from '../utils/axios';

export function useGetAuthUser() {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get('/api/v1/users/my-account');
        setUser(response.data);
      } catch (err) {
        console.error('Failed to fetch auth user:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  return { user, loading, error };
}
